import posthog from "posthog-js";

export const ANALYTICS_CONSENT_KEY = "lf_analytics_consent_v1";

const campaignParameters = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "fbclid",
];

export function readHaloCampaignAttribution(search = window.location.search) {
  const params = new URLSearchParams(search);
  return campaignParameters.reduce((attribution, key) => {
    const value = params.get(key);
    if (value) attribution[key] = value.slice(0, 200);
    return attribution;
  }, {});
}

export function captureHaloCampaignEvent(eventName, properties = {}, metaStandardEvent = "") {
  if (window.localStorage.getItem(ANALYTICS_CONSENT_KEY) !== "accepted") return false;

  const payload = {
    ...readHaloCampaignAttribution(),
    ...properties,
  };

  if (posthog.__loaded) posthog.capture(eventName, payload);

  if (typeof window.fbq === "function") {
    if (metaStandardEvent) window.fbq("track", metaStandardEvent, payload);
    else window.fbq("trackCustom", eventName, payload);
  }

  return true;
}
